import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GMobiledataIcon(props: IconProps) {
    return <Icon {...props} iconKey={"g_mobiledata"}/>
}
